import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import RadioButton from '../../../bronson/RadioButton';

function ModalOrdenar(props) {
    const [typeOrden, setTypeOrden] = useState('asc');
    const [optionOrden, setOptionOrden] = useState('');
    const [radioOptionsOrder, setRadioOptionsOrder] = useState({
        name: 'idOptionOrder',
        id: 'idOptionOrder',
        className: 'radioOptionsOrder',
        showLabel: false,
        values: [],
    });

    useEffect(() => {
        if (props.viewDisplay === 'ListadoCompleto')
            setRadioOptionsOrder({
                name: 'idOptionOrder',
                id: 'idOptionOrder',
                className: 'radioOptionsOrder',
                showLabel: false,
                values: [
                    { text: 'Score cliente', value: 'SC' },
                    { text: 'Score vehículo', value: 'SV' },
                    { text: 'Producto comercial', value: 'PC' },
                    { text: 'Fecha Vencimiento', value: 'FV' },
                    { text: 'Fecha IPO', value: 'FI' },
                    { text: 'Asesor original', value: 'AO' },
                    { text: 'Asesor asignado', value: 'AA' },
                ],
            });
        else
            setRadioOptionsOrder({
                name: 'idOptionOrder',
                id: 'idOptionOrder',
                className: 'radioOptionsOrder',
                showLabel: false,
                values: [
                    { text: 'Score cliente', value: 'SC' },
                    { text: 'Score vehículo', value: 'SV' },
                    { text: 'Producto comercial', value: 'PC' },
                    { text: 'Fecha Vencimiento', value: 'FV' },
                    { text: 'Fecha IPO', value: 'FI' },
                    { text: 'Asesor original', value: 'AO' },
                ],
            });
    }, [props.viewDisplay]);
    useEffect(() => {
        if (props.orden.length === 2) {
            setTypeOrden(props.orden[0]);
            setOptionOrden(props.orden[1]);
        }
    }, [props.orden]);

    const setOrdenApl = () => {
        if (optionOrden !== '') {
            props.setOrden([typeOrden, optionOrden]);
            props.setModalorden(false);
        }
    };

    return (
        <div className="c-modal">
            <div
                className="c-modal__overlay js-modal-close"
                onClick={() => props.setModalorden(false)}
            ></div>
            <div
                className="c-modal__wrapper modalPosition_FilterMatriz"
                role="dialog"
                aria-labelledby="foo-bar-baz"
                style={{ minHeight: '480px' }}
            >
                <header
                    className="c-modal__header"
                    style={{
                        padding: '0px',
                        paddingTop: '10px',
                    }}
                >
                    <div className="o-layout__item u-10/12 ">
                        <label
                            className=" c-modal__title"
                            style={{ display: 'inline-flex' }}
                        >
                            <i className="c-icon c-icon--[control-list-view] c-icon--small" />
                            <span className="mideltextfilter u-text-brand">
                                Ordenar
                            </span>
                        </label>
                    </div>

                    <div className="o-layout__item u-2/12">
                        <button
                            onClick={() => props.setModalorden(false)}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Cerrar modal."
                        />
                    </div>
                </header>
                <div
                    className="c-modal__content"
                    role="document"
                    style={{ marginTop: '6px', paddingBottom: '10px' }}
                >
                    <div className="u-text-left maginBoton">
                        <p>Te ayudamos a ordenar el listado de vencimientos.</p>
                    </div>
                    <div className="maginBoton">
                        <p className="u-text-left">
                            Selecciona el tipo de orden.
                        </p>
                        <RadioButton
                            value={typeOrden}
                            options={{
                                name: 'idTypeOrder',
                                id: 'idTypeOrder',
                                className: 'radioOptionsOrder',
                                showLabel: false,
                                values: [
                                    { text: 'Ascendente', value: 'asc' },
                                    { text: 'Descendente', value: 'desc' },
                                ],
                            }}
                            onChange={e => {
                                setTypeOrden(e);
                            }}
                        />
                    </div>
                    <div className="radioOptionsOrderContainer">
                        <p className="u-text-left">
                            Selecciona la columna por la que desee ordenar el
                            listado.
                        </p>
                        <RadioButton
                            value={optionOrden}
                            options={radioOptionsOrder}
                            onChange={e => setOptionOrden(e)}
                        />
                    </div>
                    <div className="o-split u-pt">
                        <button
                            className="c-btn c-btn--secondary"
                            style={{ width: '45%' }}
                            onClick={() => props.setModalorden(false)}
                        >
                            CANCELAR
                        </button>
                        <button
                            className="c-btn"
                            style={{ width: '45%' }}
                            onClick={() => setOrdenApl()}
                            disabled={optionOrden === '' ? true : false}
                        >
                            APLICAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(ModalOrdenar);
